<h2 mat-dialog-title>
  @if (erAapneOperasjon) {
    {{ 'Åpne for avstemning' | translate }}
  } @else {
    {{ 'Avslutt avstemningen' | translate }}
  }
</h2>

<!-- @todo var e2e-aapne-for-avstemning-skjema -->
<form [formGroup]="skjema" (ngSubmit)="lagre()" class="skjema">
  <mat-dialog-content>
    @if (erAapneOperasjon) {
      <!--<p>{{ "Åpne {antallAvstemninger} avstemning for {antallStemmeberettigede} stemmeberettigede"|translate:{antallAvstemninger: avstemningsstatus.antallAvstemninger, antallStemmeberettigede: avstemningsstatus.antallStemmeberettigedeDeltakere} }}</p>
      <tips>{{ "Deltakere kan stemme helt til du stenger for avstemning" | translate }}</tips>-->
    } @else {
      <!--<p>{{ "{antall} av totalt {totalt} stemmeberettigede har påbegynt avstemningen"|translate:{antall: avstemningsstatus.antallDeltakereStemtFerdig, totalt: avstemningsstatus.antallStemmeberettigedeDeltakere} }}</p>
      <p>{{ "{antall} av totalt {totalt} stemmeberettigede har fullført avstemningen"|translate:{antall: avstemningsstatus.antallDeltakereStemtDelvis, totalt: avstemningsstatus.antallStemmeberettigedeDeltakere} }}</p>
      <p>{{ "{antall} av totalt {totalt} stemmeberettigede har ikke stemt på noen avstemninger"|translate:{antall: avstemningsstatus.antallDeltakereStemtIngen, totalt: avstemningsstatus.antallStemmeberettigedeDeltakere} }}</p>-->
      <tips>{{ "Du kan gjenåpne for avstemning senere" | translate }}</tips>
    }
    <fieldset>
      <mat-slide-toggle [formControl]="skjema.controls.sendMelding"
                        matTooltip="{{'Dersom valgt sendes e-post til alle respondenter med informasjon at spørreundersøkelsen er avsluttet' | translate}}">
        {{ "Informer {antall} stemmeberettigede" | translate:{antall: avstemningsstatus.antallStemmeberettigedeDeltakere} }}
      </mat-slide-toggle>
      @if (skjema.value.sendMelding) {
        <mat-form-field>
          <mat-label>{{ "Melding inkludert i e-post til respondentene"|translate }}</mat-label>
          <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed"/>
        </mat-form-field>
      }
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <div>
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" type="submit" cdkFocusInitial
              [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
              spinnerTekst="{{'Lagrer...'|translate}}" data-testid="lagre">
        @if (erAapneOperasjon) {
          @if (skjema.value.sendMelding){
            {{ 'Åpne for avstemning og send invitasjon' | translate }}
          } @else {
            {{ 'Åpne for avstemning' | translate }}
          }
        } @else {
          @if (skjema.value.sendMelding){
            {{ 'Steng for avstemning og send melding' | translate }}
          } @else {
            {{ 'Steng for avstemning' | translate }}
          }
        }
      </button>
    </div>
  </mat-dialog-actions>
</form>
